import React from 'react';
import {designSystemToken} from '@lightricks/react-design-system';

type DividerProps = {
  margin?: number;
  vertical?: boolean;
  width?: number | string;
  height?: number | string;
  color?: string;
  style?: React.CSSProperties;
};

function Divider({
  margin = 32,
  vertical = false,
  width = 1,
  height,
  color = designSystemToken('semantic.bg.neutral-secondary'),
  style = {},
}: DividerProps) {
  const getVerticalStyle = () => {
    if (vertical) {
      return {
        display: 'flex',
        width,
        marginTop: 0,
        marginBottom: 0,
        marginLeft: margin - 8,
        marginRight: margin - 8,
        height: height || '100%',
      };
    }
    return {};
  };
  return (
    <div
      style={{
        height: 1,
        width: '100%',
        backgroundColor: color,
        marginTop: margin,
        marginBottom: margin,
        ...getVerticalStyle(),
        ...style,
      }}
    />
  );
}

export default Divider;
